(() => {
  const sliders = new Map();

  const toBoolean = (value) => value === 'true';

  const pauseVideos = (swiper) => {
    swiper.slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) video.pause();
    });
  };

  const playActiveVideo = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    const video = activeSlide.querySelector('video');
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const updateBarTitle = (swiper) => {
    const root = swiper.el.closest('[data-product-hero-banner]');
    if (!root) return;
    const titleEl = root.querySelector('[data-phb-bar-title]');
    if (!titleEl) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const title = activeSlide.getAttribute('data-phb-title') || '';
    const link = activeSlide.getAttribute('data-phb-link') || '#';

    titleEl.textContent = title;
    titleEl.setAttribute('href', link || '#');
  };

  const mountSlider = (container) => {
    if (!window.Swiper || sliders.has(container)) return;

    const swiperElement = container.querySelector('.product-hero-banner__swiper');
    if (!swiperElement) return;

    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
    const effect = container.dataset.effect === 'fade' ? 'fade' : 'slide';
    const prevEl = swiperElement.querySelector('.product-hero-banner__nav-btn--prev');
    const nextEl = swiperElement.querySelector('.product-hero-banner__nav-btn--next');

    const swiper = new Swiper(swiperElement, {
      effect,
      loop: slideCount > 1,
      speed: 800,
      watchSlidesProgress: true,
      autoplay:
        slideCount > 1 && toBoolean(container.dataset.autoplay)
          ? {
              delay: Number(container.dataset.interval) || 6000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : false,
      fadeEffect: {
        crossFade: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        init(swiperInstance) {
          pauseVideos(swiperInstance);
          playActiveVideo(swiperInstance);
          updateBarTitle(swiperInstance);
        },
        slideChange(swiperInstance) {
          pauseVideos(swiperInstance);
          playActiveVideo(swiperInstance);
          updateBarTitle(swiperInstance);
        },
      },
    });

    sliders.set(container, swiper);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-product-hero-banner]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    const swiper = sliders.get(container);
    if (!swiper) return;
    swiper.destroy(true, true);
    sliders.delete(container);
  };

  const init = () => {
    if (window.Swiper) {
      mountAll();
      return;
    }
    window.addEventListener('load', mountAll, { once: true });
  };

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-product-hero-banner]').forEach(destroySlider);
  });
})();
